import React, { useLayoutEffect, useRef, useState } from 'react';
import { Layout, Seo } from '@layout';
import { homePageData } from '@data-ts/pages/home';
import { HomeHeroSection } from '@sections/home/HomeHeroSection/HomeHeroSection';
import { HomeNewsSection } from '@sections/home/HomeNewsSection';
import { gsap } from 'gsap';
import { useTheme } from '@styledComponents';
import { useIsMounted } from '@hooks/useIsMounted';
import { topHeaderLinkHeroTransitionClassName } from 'src/layout/Header.styles';
import { ProductFeaturesSection, ProductFeaturesSectionMob } from '@sections/home/ProductFeaturesSection';
import { WaterfallCouple } from '@sections/home/WaterfallCouple/WaterfallCouple';
import { ExpertCurations } from '@sections/home/ExpertCurations';
import { Writersblock } from '@sections/home/Writersblock';

const IndexPage: React.SFC = () => {
  const headerRef = useRef<HTMLElement>(null);
  const [headerTimeline, setHeaderTimeline] = useState<Maybe<gsap.core.Timeline>>();
  const theme = useTheme();
  const isMounted = useIsMounted();

  useLayoutEffect(() => {
    let newHeaderTimeline: ReturnType<typeof gsap.timeline>;
    if (isMounted && headerRef.current) {
      newHeaderTimeline = gsap.timeline({ paused: true });
      const textBlockColorTo = theme.colors.linkDefault;
      newHeaderTimeline.to(
        headerRef.current.querySelectorAll(`a.${topHeaderLinkHeroTransitionClassName}`),
        {
          color: textBlockColorTo,
        },
        0
      );
      setHeaderTimeline(newHeaderTimeline);
    }
  }, [isMounted, theme]);

  return (
    <Layout headerRef={headerRef} headerScrollThresholdVh={35} isTransparentHeader={true} page="home">
      <Seo title={homePageData.seo.title} description={homePageData.seo.content} canonicalURL={'https://withjoy.com/'} />
      <HomeHeroSection />
      <ProductFeaturesSection />
      <ProductFeaturesSectionMob />
      <HomeNewsSection />
      <Writersblock />
      <ExpertCurations />
      <WaterfallCouple />
    </Layout>
  );
};

export default IndexPage;
